
	import {
		Vue,
		Component,
		Watch,
	} from "vue-property-decorator";
	import Header from "@/components/base/table/header/TitleHeader.vue";
	import Search from "@/components/semantics/HomeSearch.vue";
	import PolicyTable from "@/components/base/table/body/TableTextDecoration.vue";
	import ProjectTable from "@/components/base/table/body/TableBoxText.vue";
	import CalendarTable from "@/components/base/table/header/CalendarTable.vue";
	import HomeBidDia from "@/components/base/dialog/HomeBidDia.vue";
	import HomeTestDia from "@/components/base/dialog/HomeTestDia.vue";
	import ToolTable from "@/components/base/table/body/TableImg.vue";
	import PublicyTable from "@/components/base/table/body/TableEl.vue";
	// import floatingWindow from "@/components/floatingWindow.vue";

	import { Action, Getter } from "vuex-class";
	import {
		removeHTMLTag,
	} from "@/common/utils";
	import { getDeclareItemPolicyStatisticsByCalendar, getHomePageLog } from "@/api/policy";
	import { getToolsPageList } from "@/api/policyTools";
	import { pageViewUnit } from "@/config";
	import { pageList, getCountAll } from "@/api/noApply";
	import { getStorage } from "@/common/utils";
	import cookie from "js-cookie";

	@Component({
		name: "Home",
		components: {
			Header, // text-header
			Search, // search-bar
			PolicyTable, // text-table
			ProjectTable,
			PublicyTable,
			ToolTable,
			CalendarTable,
			HomeTestDia,
			HomeBidDia,
			// floatingWindow
		},
	})
	export default class Home extends Vue {
		@Action("policy/getPolicyList") private getPolicy : any;
		@Action("policy/getApplyList") private getApplyList : any;
		@Action("policy/getPublicyPolicy") private getPublicyPolicy : any;
		@Action("policy/searchPolicyData") private getMatchList : any;
		@Action("getSearchList") private getAllSearchListData : any;
		@Getter("provinceId") private provinceId : any;
		@Getter("id") private id : any;
		@Getter("cityId") private cityId : any;
		@Getter("city") private city : any;
		@Getter("roleSave") private roleSave : any;
		@Getter("cityName") private cityName! : string;

		directCityList = this.$root.$data.directCityList;
		active = 0;
		className = "flexThree";
		btnList : Array<any> = [];
		tableData : any = [];
		loading = false;
		dialogVisible = false;
		modelShow = false;
		dialogShow = false;
		// tableData
		policyData : any = [];
		projectData : any = [];
		publicyData : any = [];
		newPublicyData : any = [];
		// loading
		loading_policy = false;
		loading_project = false;
		matchList = [];
		searchValue : any = "";
		getCalendarAndRightList = [];
		policyToolData : any = [];
		toolData = [
			{
				src: require("@images/icon/tool_service_0.png"),
				name: "高新技术企业认定诊断工具",
				path: "/pcm/verify",
				tag: "享政策补贴 税收减免",
			},
			{
				src: require("@images/icon/tool_service_1.png"),
				name: "研发费用加计扣除",
				path: "/pcm/productSale",
				tag: "一键评测 享税收优惠",
			},
			{
				src: require("@images/icon/tool_service_2.png"),
				name: "重点软件企业诊断工具",
				path: "/pcm/tax",
				tag: "精准诊断 享税率优惠",
			},
		];
		loading_publicy = false;
		yearList = [
			{
				value: "2022",
				label: "2022年",
			},
			{
				value: "2021",
				label: "2021年",
			},
			{
				value: "2020",
				label: "2020年",
			},
			{
				value: "2019",
				label: "2019年",
			},
			{
				value: "2018",
				label: "2018年",
			},
			{
				value: "2017",
				label: "2017年",
			},
			{
				value: "2016",
				label: "2016年",
			},
			{
				value: "2015",
				label: "2015年",
			},
			{
				value: "2014",
				label: "2014年",
			},
			{
				value: "2013",
				label: "2013年",
			},
			{
				value: "2012",
				label: "2012年",
			},
			{
				value: "2011",
				label: "2011年",
			},
			{
				value: "2010",
				label: "2010年",
			},
		];

		monthsList = [
			{
				value: "01",
				label: "1月",
			},
			{
				value: "02",
				label: "2月",
			},
			{
				value: "03",
				label: "3月",
			},
			{
				value: "04",
				label: "4月",
			},
			{
				value: "05",
				label: "5月",
			},
			{
				value: "06",
				label: "6月",
			},
			{
				value: "07",
				label: "7月",
			},
			{
				value: "08",
				label: "8月",
			},
			{
				value: "09",
				label: "9月",
			},
			{
				value: "10",
				label: "10月",
			},
			{
				value: "11",
				label: "11月",
			},
			{
				value: "12",
				label: "12月",
			},
		];
		yearValue = "";
		monthValue = "";
		// value = new Date();
		value = "2022-03-13";
		CountAll = {};
		currentItem = {};
		tabPosition = "month";
		tabPolicy = "hqzs";
		checkVal = "";
		calendarRightData = [
			{
				title:
					"北京市经济和信息化局 关于开展2021年新增小微企业融资担保业务 降费奖补项目申报工作的通知",
				type: "认定奖励",
				department: "北京市经济和信息化局",
				date: "2022-02-23",
			},
			{
				title: "科技创新小巨人补贴",
				type: "资金补助",
				department: "北京市科学技术委员会",
				date: "2022-03-11",
			},
			{
				title: "市服务贸易示范和重点培育企业奖励",
				type: "认定奖励",
				department: "北京市商务局",
				date: "2022-03-15",
			},
		];
		freeTableData = [
			{
				enjoyId: "70a7b002-937d-423a-a288-c89654910fa9",
				itemName: "重大项目实施——国家高新技术企业奖励",
				policyId: "152d629bd7db4bb4a80b9e4ee5344125",
				addressCode: "410702",
				departmentId: "1684",
				nature: "资金补贴",
				type: "资金奖励",
				amount: "1,000,000元",
				content: "对于获得北京市科技重大专项资金扶持的项目配套奖励标准为100万元",
				getItems: null,
				releaseTime: "2022-03-14",
				closingDate: "2022-10-30",
				enterpriseId: null,
				operatePerson: "admin",
				createTime: "2021-10-26",
				updateTime: "2021-10-26",
				deleteFlag: 0,
				policyName: "北京市人民政府关于印发北京市科技创新奖励管理办法的通知",
				departmentName: "北京市科学技术委员会",
				status: 0,
				enterpriseName: null,
				examineComments: null,
				examineTime: null,
				isShow: 1,
				title: "重大项目实施——国家高新技术企业奖励",
				depart: "北京市科学技术委员会",
				deadline: "2022-03-31",
				year: 2022,
				date: "3/31",
				isDead: false,
				timeStatus: 1,
				day: 45,
			},
			{
				enjoyId: "4eb6e99a-86f7-4237-bf5b-28262b3020cd",
				itemName: "企业资质提升——省级创新龙头企业奖励",
				policyId: "152d629bd7db4bb4a80b9e4ee5344125",
				addressCode: "410702",
				departmentId: "1684",
				nature: "资金补贴",
				type: "资金奖励",
				amount: "500,000元",
				content:
					"对于新认定的省级创新龙头企业奖励标准为50万元。（区属事业单位通过市级创新型单位认定的可享受此项政策）",
				getItems: null,
				releaseTime: "2022-03-19",
				closingDate: "2022-10-23",
				enterpriseId: null,
				operatePerson: "admin",
				createTime: "2021-10-26",
				updateTime: "2021-10-26",
				deleteFlag: 0,
				policyName: "北京市人民政府关于印发北京市科技创新奖励管理办法的通知",
				departmentName: "北京市人民政府",
				status: 0,
				enterpriseName: null,
				examineComments: null,
				examineTime: null,
				isShow: 1,
				title: "企业资质提升——省级创新龙头企业奖励",
				depart: "北京市人民政府",
				deadline: "2022-03-31",
				year: 2022,
				date: "3/31",
				isDead: false,
				timeStatus: 0,
				day: 0,
			},
			{
				enjoyId: "91db6e3d-3f55-44af-b34d-182d6ba1a703",
				itemName: "重大项目实施——北京市重大科技创新专项资金扶持奖励",
				policyId: "152d629bd7db4bb4a80b9e4ee5344125",
				addressCode: "410702",
				departmentId: "1684",
				nature: "资金补贴",
				type: "资金奖励",
				amount: "400,000元",
				content:
					"对于获得北京市重大科技创新专项资金扶持的项目配套奖励标准为40万元",
				getItems: null,
				releaseTime: "2022-03-13",
				closingDate: "2022-09-28",
				enterpriseId: null,
				operatePerson: "admin",
				createTime: "2021-10-26",
				updateTime: "2021-10-26",
				deleteFlag: 0,
				policyName: "北京市人民政府关于印发北京市科技创新奖励管理办法的通知",
				departmentName: "北京市人民政府",
				status: 0,
				enterpriseName: null,
				examineComments: null,
				examineTime: null,
				isShow: 1,
				title: "重大项目实施——北京市重大科技创新专项资金扶持奖励",
				depart: "北京市人民政府",
				deadline: "2022-03-31",
				year: 2022,
				date: "3/31",
				isDead: false,
				timeStatus: 1,
				day: 12,
			},
			{
				enjoyId: "ab188f3a-7758-4f76-b67e-eb70b8395819",
				itemName: "科技成果转化——省级科技进步奖奖励",
				policyId: "152d629bd7db4bb4a80b9e4ee5344125",
				addressCode: "410702",
				departmentId: "1684",
				nature: "资金补贴",
				type: "资金奖励",
				amount: "100,000元",
				content:
					"对于新认定的省级科技进步奖的我区主要完成单位或主要完成人奖励标准按1:1配套奖励，奖励金额最高10万元。",
				getItems: null,
				releaseTime: "2022-03-12",
				closingDate: "2022-09-10",
				enterpriseId: null,
				operatePerson: "admin",
				createTime: "2021-10-26",
				updateTime: "2021-10-26",
				deleteFlag: 0,
				policyName: "北京市人民政府关于印发北京市科技创新奖励管理办法的通知",
				departmentName: "北京市人民政府",
				status: 0,
				enterpriseName: null,
				examineComments: null,
				examineTime: null,
				isShow: 1,
				title: "科技成果转化——省级科技进步奖奖励",
				depart: "北京市人民政府",
				deadline: "2022-03-31",
				year: 2022,
				date: "3/31",
				isDead: false,
				timeStatus: 1,
				day: 12,
			},
			{
				enjoyId: "ed992fe8-fb69-42b0-9737-40b7bf5fc722",
				itemName: "企业资质提升——北京市科技重大专项资金扶持奖励",
				policyId: "152d629bd7db4bb4a80b9e4ee5344125",
				addressCode: "410702",
				departmentId: "1684",
				nature: "资金补贴",
				type: "资金奖励",
				amount: "200,000元",
				content: "对于新认定的国家高新技术企业奖励标准为20万元",
				getItems: null,
				releaseTime: "2022-03-02",
				closingDate: "2022-08-18",
				enterpriseId: null,
				operatePerson: "admin",
				createTime: "2021-10-26",
				updateTime: "2021-10-26",
				deleteFlag: 0,
				policyName: "北京市人民政府关于印发北京市科技创新奖励管理办法的通知",
				departmentName: "北京市人民政府",
				status: 0,
				enterpriseName: null,
				examineComments: null,
				examineTime: null,
				isShow: 1,
				title: "企业资质提升——北京市科技重大专项资金扶持奖励",
				depart: "北京市人民政府",
				deadline: "2022-03-04",
				year: 2022,
				date: "3/4",
				isDead: true,
				timeStatus: 1,
				day: 5,
			},
		];
		interpretationData = [
			// {
			//   title:'发展高端仪器装备和传感器产业',
			//   tags:['资金补贴','高端装备','中小微企业'],
			//   department:'北京市科学技术委员会',
			//   date: '2021-12-10'
			// },
			// {
			//   title:'2021年‘贷免扶补’小额贷款待放款的申报',
			//   tags:['金融贴息','金融贴息','小微企业'],
			//   department:'北京市财政厅',
			//   date: '发布日期：2021-09-10'
			// },
			// {
			//   title:'三批工信部专精特新“小巨人”奖励',
			//   tags:['资金补贴','服务业','小微企业'],
			//   department:'北京市工业信息化局',
			//   date: '2021-09-10'
			// }
		];
		consultList = [
			{
				question: "专精特新申请条件",
				answer:
					"您好！专精特新申报条件：推荐省级“专精特新”中小企业主要从已纳入《全省“专精特新”中小企业发展规划》且并公布为市级“专精特新”中小企业中选出。应符合以下基本条件和任意一项专项条件。\n" +
					"（一）、基本条件：1.在我省登记注册两年以上，具有独立法人资格，符合《中小企业划型标准规定》(工信部联企业〔2011〕300号)界定，具有良好发展前景和较好的经济、社会效益，信用良好的中小企业。\n" +
					"\n" +
					"2.企业上年度营业收入1000万元以上，近两年平均营业收入增速不低于10%。\n" +
					"\n" +
					"3、通过质量管理体系认证，产品质量稳定可靠。\n" +
					"\n" +
					"4、节能、环保和安全生产等符合国家和省里相关规定，银行信用、纳税信用和社会信用良好。\n" +
					"(二)、专项条件：1.专业化：企业专注核心业务，具有较高专业化生产、服务和协作配套能力，能为大企业、大项目和龙头企业提供关键零部件、关键元器件、配套产品和配套服务。\n" +
					"\n" +
					"2.精细化：企业建立精细高效的管理制度和流程，取得质量管理体系认证，开展精细化生产、精细化管理、精细化服务，企业管理效益突出、降本增效显著。企业产品品牌和服务美誉度高、性价比好、品质精良，在细分市场具有一定的比较优势。\n" +
					"\n" +
					"3.特色化：企业利用特色资源，弘扬传统技艺和地域文化，采用独特工艺、技术、配方或原料，研制生产具有地方或企业特色的产品。\n" +
					"\n" +
					"4.创新化：开展技术创新、管理创新和商业模式创新，适应或创造消费新需求，拥有符合“新技术、新产业、新业态、新模式”等四新经济发展特征的产品或服务，形成新的经济增长点，具有新的竞争优势。具有较高的信息化、智能化应用水平，通过行业的交叉融合提供新的产品或服务，拥有近2年内新授权的发明专利或独特、独有的工艺、配方等专有技术。\n" +
					"(三)、有下列情况之一的企业不得申请省级“专精特新”中小企业：1.近两年发生过安全、质量和环境污染事故;\n" +
					"\n" +
					"2.有不良会计信用、纳税信用和银行信用记录;\n" +
					"\n" +
					"3.有其他违法违规受处罚现象。",
				time: "2021-12-31  09:12:31",
			},
			{
				question: "高新技术企业认定条件",
				answer:
					"1、企业申请认定时须注册成立一年以上；\n" +
					" 2、企业通过自主研发、受让、受赠、并购等方式，获得对其主要产品（服务）在技术上发挥核心支持作用的知识产权的所有权；\n" +
					" 3、对企业主要产品（服务）发挥核心支持作用的技术属于《国家重点支持的高新技术领域》规定的范围；\n" +
					" 4、企业从事研发和相关技术创新活动的科技人员占企业当年职工总数的比例不低于10%；\n" +
					" 5、企业近三个会计年度（实际经营期不满三年的按实际经营时间计算，下同）的研究开发费用总额占同期销售收入总额的比例符合如下要求：\n" +
					"         （1）最近一年销售收入小于5,000万元（含）的企业，比例不低于5%；\n" +
					"\n" +
					"         （2）最近一年销售收入在5,000万元至2亿元（含）的企业，比例不低于4%；\n" +
					"\n" +
					"         （3）最近一年销售收入在2亿元以上的企业，比例不低于3%；\n" +
					"\n" +
					"         其中，企业在中国境内发生的研究开发费用总额占全部研究开发费用总额的比例不低于60%；\n" +
					" 6、近一年高新技术产品（服务）收入占企业同期总收入的比例不低于60%；\n" +
					"7、企业创新能力评价应达到相应要求；\n" +
					" 8、企业申请认定前一年内未发生重大安全、重大质量事故或严重环境违法行为。",
				time: "2021-10-12  15:32:13",
			},
		];
		consultActive = 0;
		consultBtnList = ["常见咨询", "公开咨询"];
		homeData = [
			{
				src: require("@images/policy/home01.png"),
				href: "http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm",
			},
			{
				src: require("@images/policy/home02.png"),
				href: "http://www.gov.cn/fuwu/2022-11/01/content_5723246.htm",
			},
			{
				src: require("@images/policy/home03.png"),
				href: "http://www.huangshi.gov.cn/ztjj/sjss/#",
			},
			{
				src: require("@images/policy/home04.jpg"),
				href: "http://www.gov.cn/zhengce/content/2022-05/31/content_5693159.htm",
			},
			{
				src: require("@images/policy/home05.png"),
				href: "https://mp.weixin.qq.com/s/50si2Pabe4BqINul4r-Gcg",
			},
			{
				src: require("@images/policy/home07.png"),
				href: "http://www.huangshi.gov.cn/xxxgk/2020_zc/2020_gfxwj/202207/t20220714_922254.html",
			},
			{
				src: require("@images/policy/home06.png"),
				href: "http://jxw.huangshi.gov.cn/zwgk/fgyjd/zcwj/202202/P020220216598481005423.pdf",
			},
		];
		restaurants = [];
		created() {
			this.value = GetCurrentTime();
			this.yearValue = this.value.split("-")[0];
			this.monthValue = this.value.split("-")[1];
			let userNameValue = ''
			if (!getStorage("basic")) {
				userNameValue = '浏览用户'
			} else {
				userNameValue = getStorage("basic").username
			}
			getHomePageLog({ username: userNameValue }).then(res => {
				console.log(res, 8888)
			})
			this.setPublicyTabData();
			this.getData();
			this.getToolsPageListThree();
			this.getRecomData();
		}
		goCheck() {
			if (this.checkVal) {
				this.$router.push({
					path: "/pcm/allpolicy",
					query: {
						params: this.checkVal,
					},
				});
			} else {
				this.$message.error("请填写查找内容");
			}
		}
		async showNewList() {
			this.$router.push({
				path: "/pcm/newList",
			});
		}
		async setPublicyTabData() {
			const { cityName, provinceName, centerName } =
				this.$root.$data.currentAreaProps;
			if (this.directCityList.includes(this.cityId)) {
				this.btnList = ["国家", "湖北省", cityName];
			} else {
				this.btnList = ["国家", "湖北省", cityName];
			}
		}
		async getAllSearchList(search : any) {
			const options = {
				cityName: this.cityName,
				corporateName: search,
			};
			const res = await this.getAllSearchListData(options);
			return res;
		}
		async querySearch(queryString : any, cb : any) {
			let restaurants : any = [];
			const originRestaurants = await this.getAllSearchList(queryString);
			restaurants = originRestaurants;
			this.restaurants = restaurants;
			const results = queryString
				? restaurants.filter((item : any) => item.value.indexOf(queryString) >= 0)
				: restaurants;
			// 调用 callback 返回建议列表的数据
			cb(results);
		}
		searchData(word : any) {
			if (!getStorage("basic")) {
				return this.$message.warning("请先登录");
			}
			if (!this.searchValue && !word) {
				return this.$message.error("请填写匹配内容");
			}
			const filterRes = this.restaurants.find((item : any) => {
				return item.value === this.searchValue;
			});
			if (!filterRes) {
				return this.$message.warning("无法匹配该企业");
			}
			this.$router.push({
				path: "/pcm/company",
				query: { params: this.searchValue || word },
			});
		}
		handleSelect() { }
		toMatch({ id, declareItemId } : any) {
			this.$router.push({
				path: "/detail/apply",
				query: {
					projectId: declareItemId,
					directionId: id,
				},
			});
		}
		getRecomData() {
			const unitList = ["unit", "declare"];
			let options : any = {
				pageNumber: 1,
				pageSize: 3,
				order: "desc",
				sort: "releaseDate",
				locationAddressCode: this.city.locationAddressCode,
			};
			if (!this.city.locationAddressCode) {
				options.addressCode = this.city.id;
			}
			this.getMatchList(options)
				.then((res : any) => {
					const { code, result, msg } = res;
					if (code === 200 && result) {
						this.matchList = result.list;
					}
				})
				.catch((err : any) => err);
		}
		renderButton(item : any) {
			const { declarationStatus, isCanFulfill, isFulfill } = item;
			const renturnData = {
				type: "info",
				disabled: true,
				label: "兑现已截止",
				tip: "",
			};
			if (declarationStatus === "START") {
				renturnData.label = "确认兑现";
				if (cookie.get("accessToken")) {
					//已登录
					if (this.roleSave == 1) {
						//已认证
						if (isCanFulfill == 1) {
							if (isFulfill == 1) {
								renturnData.label = "已申请";
							} else {
								renturnData.type = "primary";
								renturnData.disabled = false;
							}
						} else {
							renturnData.tip = "暂无兑现资格";
							renturnData.type = "primary";
						}
					} else {
						//未认证
						renturnData.tip = "未实名认证";
						renturnData.type = "primary";
					}
				} else {
					renturnData.disabled = false;
				}
			} else {
				renturnData.label =
					declarationStatus === "STOP" ? "兑现已截止" : "未开始兑现";
			}

			return renturnData;
		}
		toThousands(num : any) {
			if (num == 0) {
				return "--";
			}
			var num = num.toString(),
				result = "";
			// 将传入数据转换为字符串
			while (num.length > 3) {
				// 只要字符串长度大于三就执行
				result = "," + num.slice(-3) + result;
				// 将字符串后三位裁剪并加入最终的字符串
				num = num.slice(0, num.length - 3);
				// 更新字符串长度
			}
			if (num) {
				result = num + result;
			}
			return result;
		}
		async getData() {
			this.getPolicyList();
			// 最新资讯
			this.getPublicyList();
			this.getNoApply();
			this.getCount();
			// this.getProjectList();
			// this.getPublicyList();
			// this.getNewPublicyList();

			// 获取政策解读数据
			this.getInterpretationData();

			let getCalendarAndRightList = await this.getCalendarAndList({
				locationAddressCode: this.city.id,
				year: new Date().getFullYear() + "",
			});
			// 日历数据排序
			this.getCalendarAndRightList = getCalendarAndRightList
				.map((item : any, index : number) => {
					item = {
						date: index + 1,
						...item[index + 1],
					};
					return item;
				})
				.sort((a : any, b : any) => a.date - b.date);
		}

		//获取政策工具列表数据
		getToolsPageListThree() {
			this.policyToolData = [];
			let imageList = [
				require("@images/bg/tools_bg01.png"),
				require("@images/bg/tools_bg02.png"),
				require("@images/bg/tools_bg03.png"),
				require("@images/bg/tools_bg04.png"),
				require("@images/icon/tool_service_4.png"),
				require("@images/icon/tool_service_5.png"),
			];
			getToolsPageList({ pageSize: 4, pageNumber: 1 }).then((res : any) => {
				if (res.data.success) {
					let arr = res.data.result.list;
					if (arr.length > 3) {
						this.className = "flexThree";
					} else {
						this.className = "flexTwo";
					}
					arr.map((item : any, index : number) => {
						this.policyToolData.push({
							name: item.name,
							id: item.id,
							src: imageList[index % 6],
							path: "/pcm/verify",
						});
					});
				}
			});
		}
		getInterpretationData() {
			this.loading = true;

			let options : any = {
				pageNumber: 1,
				pageSize: 3,
				bigClass: "解读",
				unscrambleType: "图片解读",
				order: "desc",
				sort: "releaseDate",
				locationAddressCode: this.city.locationAddressCode,
			};
			if (!this.city.locationAddressCode) {
				options.addressCode = this.city.id;
			}

			this.getPolicy(options).then(({ code, result, msg } : any) => {
				if (code === 200 && result) {
					const { totalElements, content, totalPages } = result;
					// this.interpretationData = content.map((item: any) => {
					//   item = item.content;
					//   if (item.content && item.content.withPicturesUrl) {
					//     item.withPicturesUrl = item.content.withPicturesUrl;
					//   }
					//   return item;
					// });
					this.interpretationData = result.list;
				}
			});
		}

		//获取政策日历数据与列表数据
		async getCalendarAndList(param : any) {
			const res : any = await getDeclareItemPolicyStatisticsByCalendar(param)
				.then((res : any) => {
					const { code, result, msg } = res.data;
					return result || [];
				})
				.catch((e : string) => console.error(e));
			return res;
		}

		async getPolicyList(type = this.active) {
			this.loading_policy = true;
			const options : any = {
				pageSize: 5,
				pageNumber: 1,
				order: "desc",
				sort: "releaseDate",
				bigClass: "政策库",
				locationAddressCode: this.city.locationAddressCode,
			};

			switch (type) {
				case 0:
					{
						options.addressCode = 100000;
					}
					break;
				case 1:
					{
						options.addressCode = 420000;
						options.all = 1;
					}
					break;
				case 2:
					{
						options.addressCode = this.city.id;
					}
					break;
				default:
					break;
			}
			return this.getPolicy(options)
				.then((res : any) => {
					const { code, result } = res;
					if (code === 200) {
						// const { content } = result;
						// this.policyData = content.map((policy: any) => {
						//   const { title, releaseDate: date, id } = policy.content;
						//   return {
						//     id,
						//     title,
						//     date,
						//   };
						// });
						// return content;
						this.policyData = result.list;
					}
				})
				.catch((err : any) => err)
				.finally(() => {
					this.loading_policy = false;
				});
		}

		async getProjectList() {
			this.loading_project = true;
			const { cityId } = this.$root.$data.currentAreaProps;
			const options : any = {
				current: 1,
				size: 4,
				addressCode: cityId,
				listType: 0,
				sort: "热度",
			};
			this.getApplyList(options)
				.then((res : any) => {
					const { code, data, msg } = res;
					if (code === 0) {
						const { total, list } = data;
						this.projectData = list.map(
							({
								labels,
								department,
								gmtCreate,
								gmtEnd,
								dispatchDirection,
								supportAmount,
								...item
							} : any) => {
								const currentDate = new Date().getTime();
								const releasedDate : any = gmtCreate
									? new Date(gmtCreate).getTime()
									: null;
								const deadDate : any = gmtEnd ? new Date(gmtEnd).getTime() : null;
								const depart = department.departmentName || null;
								const title = `${item.title}(${dispatchDirection})`;
								const money = `${supportAmount ? (supportAmount / 10000).toFixed(0) : 0
									}万元`;
								delete item.title;
								let state = "";
								if (gmtCreate && currentDate) {
									if (currentDate > releasedDate) {
										state = "兑现中";
									} else {
										state = "未开始";
									}
									if (deadDate && currentDate > deadDate) {
										state = "已截止";
									}
								}
								const label =
									labels.indexOf(",") > 0
										? labels.split(",")
										: labels.split("，");
								return {
									title,
									depart,
									tags: [money, label.length > 0 ? label[0] : null, state],
									...item,
								};
							}
						);
						return list;
					}
				})
				.catch((err : any) => err)
				.finally(() => (this.loading_project = false));
		}

		async getPublicyList() {
			this.loading_publicy = true;
			const options : any = {
				pageNumber: 1,
				pageSize: 5,
				bigClass: "政策库",
				order: "desc",
				sort: "releaseDate",
				locationAddressCode: this.city.locationAddressCode,
			};
			if (!this.city.locationAddressCode) {
				options.addressCode = this.city.id;
			}
			this.getPublicyPolicy(options)
				.then((res : any) => {
					const { code, result, msg } = res;
					if (code === 200) {
						// const { content } = result;
						// this.publicyData = content.map(({ content }: any) => {
						//   return content;
						// });
						// return content;
						this.publicyData = result.list;
					}
				})
				.catch((err : any) => err)
				.finally(() => (this.loading_publicy = false));
		}
		// 无申请兑现
		async getNoApply() {
			// 0-default|1-search
			this.loading = true;
			let options = {
				pageNumber: 1,
				pageSize: 3,
				order: "desc",
				// sort: "releaseDate",
				addressCode: "",
				locationAddressCode: this.city.locationAddressCode,
			};
			if (!this.city.locationAddressCode) {
				options.addressCode = this.city.id;
			}
			pageList(options)
				.then((res) => {
					let { code, result, msg } = res.data;
					if (code === 200) {
						const { total, list, size } = result;
						this.freeTableData = list.map((item : any) => {
							return item;
						});
					}
				})
				.finally(() => (this.loading = false));
		}
		// 首页统计
		async getCount() {
			// 0-default|1-search
			this.loading = true;
			let options = {
				addressCode: "",
				locationAddressCode: this.city.locationAddressCode,
			};
			if (!this.city.locationAddressCode) {
				options.addressCode = this.city.id;
			}
			getCountAll(options)
				.then((res) => {
					let { code, result, msg } = res.data;
					if (code === 200) {
						this.CountAll = result;
					}
				})
				.finally(() => (this.loading = false));
		}

		// 申办
		immediatelyDeclare(data : any) {
			(this.$refs.HomeBidDia as any).show(data);
		}

		// 自测
		startTest(data : any) {
			// (this.$refs.HomeTestDia as any).show(data)
			window.open(data.selfTest);
		}
		formatDecimal(num : any) {
			if (num) {
				let thousands = num / 100000000;
				return parseFloat(thousands).toFixed(2);
			} else {
				return "--";
			}
		}
		async getNewPublicyList() {
			const { provinceId, cityId, cityList } = this.$root.$data.currentAreaProps;
			const allArea = cityList.concat([provinceId], [cityId]);
			const options : any = {
				current: 1,
				size: 2,
				addressCodeList: allArea,
				sort: null,
			};
			this.getPublicyPolicy(options)
				.then((res : any) => {
					const { code, data, msg } = res;

					if (code === 0) {
						const { records } = data;
						this.newPublicyData = records.map(
							({
								addressCode,
								lead: htmlContent,
								releaseDate,
								department,
								id,
								title,
								deadline,
								pageView,
							} : any) => {
								const release_date = new Date(releaseDate);
								const dead_date = new Date(deadline);
								const current_date = new Date();
								let stater = 0;
								if (current_date.getTime() < release_date.getTime()) {
									stater = 0;
									// not publish
								} else if (current_date.getTime() > dead_date.getTime()) {
									// deadline
									stater = 2;
								} else {
									stater = 1;
								}
								let content = "";
								if (htmlContent) {
									content = removeHTMLTag(htmlContent);
								}
								return {
									addressCode,
									content,
									releaseDate,
									department,
									id,
									title,
									stater,
									pageView: pageView + pageViewUnit,
								};
							}
						);
						return records;
					}
				})
				.catch((err : any) => err);
		}

		clickPolicyLabel({ id: publicyId } : any, column : any, e : any) {
			this.$router.push({
				path: "/detail/policy",
				query: { publicyId },
			});
		}

		clickPublicyLabel({ id: publicyId } : any, column : any, e : any) {
			// this.$router.push({
			//   path: "/pcm/policyDetail",
			//   query: { publicyId },
			// });
			const url = `/#/pcm/policyDetail?publicyId=${publicyId}`;
			window.open(url, "_blank");
		}

		clickPolicyBtn(index : any) {
			this.active = index;
			switch (index) {
				case 0:
					this.getPolicyList(0);
					break;
				case 1:
					this.getPolicyList(1);
					break;
				case 2:
					this.getPolicyList(2);
					break;
				default:
					this.getPolicyList(0);
					break;
			}
		}
		toMoreNews() {
			this.$router.push({ path: "pcm/policy" });
		}
		handleClose() {
			this.dialogVisible = false;
		}
		toPolicyData(index : number) {
			if (index == 0) {
				// this.$router.push({
				//   path: "/pcm/policyDetail",
				//   query: {
				//     policyId: "2633dc6183b94e149b5b99ca1845b0be",
				//   },
				// });
				const url = `/#/pcm/policyDetail?publicyId=2633dc6183b94e149b5b99ca1845b0be`;
				window.open(url, "_blank");
			}
		}
		toInquiry() {
			this.modelShow = true;
		}
		closeInquiryModal() {
			this.modelShow = false;
		}
		policyInterpretation(item : any) {
			this.$router.push({
				path: "/detail/text",
				query: { textId: item.id },
			});
			// if(index == 0){
			//   this.$router.push({path: "/detail/text",query:{
			//       textId:'ca7f39a26c614105be09810874cfb308'
			//     }});
			// }
		}
		clickConsultBtn(index : any) {
			this.consultActive = index;
			switch (index) {
				case 0:
					this.consultList = [
						{
							question: "专精特新申请条件",
							answer:
								"您好！专精特新申报条件：推荐省级“专精特新”中小企业主要从已纳入《全省“专精特新”中小企业发展规划》且并公布为市级“专精特新”中小企业中选出。应符合以下基本条件和任意一项专项条件。\n" +
								"（一）、基本条件：1.在我省登记注册两年以上，具有独立法人资格，符合《中小企业划型标准规定》(工信部联企业〔2011〕300号)界定，具有良好发展前景和较好的经济、社会效益，信用良好的中小企业。\n" +
								"\n" +
								"2.企业上年度营业收入1000万元以上，近两年平均营业收入增速不低于10%。\n" +
								"\n" +
								"3、通过质量管理体系认证，产品质量稳定可靠。\n" +
								"\n" +
								"4、节能、环保和安全生产等符合国家和省里相关规定，银行信用、纳税信用和社会信用良好。\n" +
								"(二)、专项条件：1.专业化：企业专注核心业务，具有较高专业化生产、服务和协作配套能力，能为大企业、大项目和龙头企业提供关键零部件、关键元器件、配套产品和配套服务。\n" +
								"\n" +
								"2.精细化：企业建立精细高效的管理制度和流程，取得质量管理体系认证，开展精细化生产、精细化管理、精细化服务，企业管理效益突出、降本增效显著。企业产品品牌和服务美誉度高、性价比好、品质精良，在细分市场具有一定的比较优势。\n" +
								"\n" +
								"3.特色化：企业利用特色资源，弘扬传统技艺和地域文化，采用独特工艺、技术、配方或原料，研制生产具有地方或企业特色的产品。\n" +
								"\n" +
								"4.创新化：开展技术创新、管理创新和商业模式创新，适应或创造消费新需求，拥有符合“新技术、新产业、新业态、新模式”等四新经济发展特征的产品或服务，形成新的经济增长点，具有新的竞争优势。具有较高的信息化、智能化应用水平，通过行业的交叉融合提供新的产品或服务，拥有近2年内新授权的发明专利或独特、独有的工艺、配方等专有技术。\n" +
								"(三)、有下列情况之一的企业不得申请省级“专精特新”中小企业：1.近两年发生过安全、质量和环境污染事故;\n" +
								"\n" +
								"2.有不良会计信用、纳税信用和银行信用记录;\n" +
								"\n" +
								"3.有其他违法违规受处罚现象。",
							time: "2021-12-31  09:12:31",
						},
						{
							question: "高新技术企业认定条件",
							answer:
								"1、企业申请认定时须注册成立一年以上；\n" +
								" 2、企业通过自主研发、受让、受赠、并购等方式，获得对其主要产品（服务）在技术上发挥核心支持作用的知识产权的所有权；\n" +
								" 3、对企业主要产品（服务）发挥核心支持作用的技术属于《国家重点支持的高新技术领域》规定的范围；\n" +
								" 4、企业从事研发和相关技术创新活动的科技人员占企业当年职工总数的比例不低于10%；\n" +
								" 5、企业近三个会计年度（实际经营期不满三年的按实际经营时间计算，下同）的研究开发费用总额占同期销售收入总额的比例符合如下要求：\n" +
								"         （1）最近一年销售收入小于5,000万元（含）的企业，比例不低于5%；\n" +
								"\n" +
								"         （2）最近一年销售收入在5,000万元至2亿元（含）的企业，比例不低于4%；\n" +
								"\n" +
								"         （3）最近一年销售收入在2亿元以上的企业，比例不低于3%；\n" +
								"\n" +
								"         其中，企业在中国境内发生的研究开发费用总额占全部研究开发费用总额的比例不低于60%；\n" +
								" 6、近一年高新技术产品（服务）收入占企业同期总收入的比例不低于60%；\n" +
								"7、企业创新能力评价应达到相应要求；\n" +
								" 8、企业申请认定前一年内未发生重大安全、重大质量事故或严重环境违法行为。",
							time: "2021-10-12  15:32:13",
						},
					];
					break;
				case 1:
					this.consultList = [
						{
							question: "企业研究开发资助项目需要哪些材料？",
							answer:
								"您好，企业研究开发资助项目需要提交的材料如下:（一）登录深圳市科技业务管理系统（业务申请-市科技创新委-科技计划-项目申报-+申请项目-三、创新创业专项-企业研究开发资助）在线填报申请书，并进入“科研人员（专家）登录”模块，进行科研人员登记。\n" +
								"（二）2019年度研发费用专项审计报告应符合以下要求：\n" +
								"1.由近三年无不良记录的会计师事务所出具，经深圳市注册会计师协会备案且含有防伪标识，或由具备企业研发资助专项审计报告编制资质的税务师事务所出具，经深圳市税务师协会备案且含有防伪标识。\n" +
								"2.研究开发项目应符合《国家重点支持的高新技术领域》，研发费用归集范围和计算比例按照《关于完善研究开发费用税前加计扣除政策的通知》（财税〔2015〕119号）、《国家税务总局关于研发费用税前加计扣除归集范围有关问题的公告》（国家税务总局公告2017年第40号）等政策文件的规定执行。\n" +
								"（三）科研诚信承诺书原件。\n" +
								"特别提醒\n" +
								"1.建议申请单位按照附件1模板提供专项审计报告。该模板仅供本年度申请单位参考，不作强制性要求。原则上今后年度申请单位应当按该模板编制专项审计报告。\n" +
								"2.研发费用申报数为0的，不予资助。申报单位申请书中研发费用申报数应与上年度研发费用专项审计报告中的研发费用数保持一致，请特别注意申请单位申请书研发费用申报金额单位应为万元。\n" +
								"3.科技统计报表应报未报、企业内部研发机构应填未填的，不予资助。申报单位应按照统计法规的要求如实完整填报科技统计报表。\n" +
								"4.申报单位上年度研发费用申报金额，比税务部门确认的符合加计扣除政策的研发费用金额多20%及以上的企业，将被列为重点监测企业，我委将致函税务部门建议将其列为下一年度重点抽查对象。\n" +
								"5.申报单位研究开发活动涉及科研伦理与科技安全（如临床研究、信息安全等）的相关问题，申报单位应当严格遵守国家有关法律法规和伦理制度。涉及实验动物和动物实验、人的生物医学研究，应获得有关伦理审查委员会审查通过。",
							time: "2021-12-21  09:12:31",
						},
						{
							question: "申请新一代信息技术扶持计划时资助范围有哪些？",
							answer:
								"项目总投资原则上由建设投资、自主研发费、委托开发费、流动资金组成，其中： （1）建设投资主要包括设备及工器具的购置、改造与租赁费，建筑工程费（生产运营场地基础设施建设），形成固定资产的其它建设投资。（2）自主研发费用主要包括材料费、测试化验加工费、差旅费、会议费、国际合作与交流费、出版/文献/信息传播/知识产权费、劳务费、专家咨询费、研发人员费及间接费用。（3）委托开发费用主要是指项目申报单位根据项目需要就部分委托研究开发所支付的费用。（4）流动资金主要包括燃料动力费、市场网络建设费、推广活动组织费。",
							time: "2021-11-19  10:46:21",
						},
					];
					break;
				default:
					this.getPolicyList(0);
					break;
			}
		}
		dxbz(item : any) {
			this.$alert(item.standard, "兑现标准", {
				dangerouslyUseHTMLString: true,
			});
		}
		sureDx(item : any) {
			if (cookie.get("accessToken")) {
				this.dialogShow = true;
				this.currentItem = item;
			} else {
				this.$message({
					message: "请先登录",
					type: "warning",
				});
			}
		}
		empower() {
			this.dialogShow = false;
			this.$message({
				message: "授权成功",
				type: "success",
			});
			setTimeout(() => {
				this.$router.push({
					name: "ErDetails",
					query: {
						id: this.currentItem.id,
					},
				});
			}, 1000);
		}
		clickPolicyMore() {
			this.$router.push({ path: "/pcm/policy" });
		}
		clickFreeApplyMore() {
			this.$router.push({ path: "/pcm/noApply" });
		}
		clickPolicyMediaMore() {
			this.$router.push({ path: "/pcm/media" });
		}
		searchDetail(j : number) {
			if (j == 0) {
				// this.$router.push({
				//   path: "/pcm/policyDetail",
				//   query: {
				//     policyId: "d63f4b62436d4fc09fb7970ba2118082",
				//   },
				// });
				const url = `/#/pcm/policyDetail?publicyId=d63f4b62436d4fc09fb7970ba2118082`;
				window.open(url, "_blank");
			}
		}
		clickProjectLabel({ did: directionId, id: projectId } : any) {
			this.$router.push({
				path: "/detail/apply",
				query: {
					directionId,
					projectId,
				},
			});
		}

		clickPublicyMore() {
			this.$router.push({
				path: "/pcm/inform",
			});
		}
		goPolicy(policyId : any) {
			// this.$router.push({
			//   path: "/pcm/policyDetail",
			//   query: { publicyId: policyId },
			// });
			const url = `/#/pcm/policyDetail?publicyId=${publicyId}`;
			window.open(url, "_blank");
		}
		clickProjectMore() {
			this.$router.push({ path: "/pcm/apply" });
		}

		// update when cityid changed
		@Getter("cityId") private cityId : any;
		@Watch("cityId", { immediate: true })
		handleCityChange() {
			this.setPublicyTabData();
			this.getData();
		}
	}

	function GetCurrentTime() {
		let currentTime = "";
		let myDate = new Date();
		let year = myDate.getFullYear();
		let month = parseInt(myDate.getMonth().toString()) + 1; //month是从0开始计数的，因此要 + 1
		if (month < 10) {
			month = "0" + month.toString();
		}
		let date = myDate.getDate();
		if (date < 10) {
			date = "0" + date.toString();
		}
		currentTime =
			year.toString() + "-" + month.toString() + "-" + date.toString(); //返回时间的数字组合
		return currentTime;
	}
